/* Aspen main product — cloned from the {% javascript %} block inside
   td-kuya-main-product.liquid and lifted into a real asset file, per TD
   conventions.

   `td-scroll-to` is a shared element that Kuya's block also registers; the
   existing-definition guard means whichever section loads first wins and the
   other is a no-op, so the Aspen template gets it without depending on Kuya. */

if (!customElements.get('td-aspen-main-product')) {
  class TdAspenMainProduct extends HTMLElement {
    connectedCallback() {
      this.updateStickyOffset();
      this.handleResize = this.updateStickyOffset.bind(this);
      window.addEventListener('resize', this.handleResize);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
    }

    updateStickyOffset() {
      this.style.setProperty('--offsetTop', `${this.offsetTop}px`);
    }
  }

  customElements.define('td-aspen-main-product', TdAspenMainProduct);
}

if (!customElements.get('td-scroll-to')) {
  class TdScrollTo extends HTMLElement {
    connectedCallback() {
      this.handleClick = this.handleClick.bind(this);
      this.addEventListener('click', this.handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
    }

    handleClick(event) {
      event.preventDefault();
      this.scrollToTarget();
    }

    scrollToTarget() {
      const targetSelector = this.getAttribute('target');
      if (!targetSelector) return;

      const offset = parseInt(this.getAttribute('offset'), 10) || 0;
      const selectors = targetSelector.split(',').map((selector) => selector.trim());

      for (const selector of selectors) {
        const targetElement = document.querySelector(selector);
        if (targetElement) {
          const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
          const offsetPosition = elementPosition - offset;

          window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
          });
          return;
        }
      }
    }
  }

  customElements.define('td-scroll-to', TdScrollTo);
}
